<template>
  <el-dialog
    class="modal-select-store"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="content">
      <div class="filter-box">
        <el-input
          class="filter-keyword__input"
          v-model="filter.storeName"
          placeholder="请输入门店名称"
        ></el-input>
        <el-input
          class="filter-keyword__input"
          v-model="filter.storeId"
          placeholder="请输入门店ID"
        ></el-input>
        <el-select
          v-model="filter.provinces"
          class="filter-keyword__input"
          filterable
          placeholder="省份"
        >
          <el-option
            v-for="item in provinces"
            :key="item.id"
            :label="item.regionName"
            :value="item.regionCode"
          ></el-option>
        </el-select>

        <el-select class="filter-keyword__input" v-model="filter.citys" filterable placeholder="城市">
          <el-option
            v-for="item in citys"
            :key="item.id"
            :label="item.regionName"
            :value="item.regionCode"
          ></el-option>
        </el-select>

        <el-select
          v-model="filter.districts"
          class="filter-keyword__input"
          filterable
          placeholder="行政区域"
        >
          <el-option
            v-for="item in districts"
            :key="item.id"
            :label="item.regionName"
            :value="item.regionCode"
          ></el-option>
        </el-select>
        <el-button @click="$_search" class="search__btn">查询</el-button>
        <el-button @click="$_reset" class="reset__btn">重置</el-button>
      </div>

      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="storesTable"
        v-loading="isLoading"
        :data="dataList"
        height="296"
        highlight-current-row
        @current-change="$_changeSelected"
        stripe
        tooltip-effect="dark"
      >
        <el-table-column width="50">
          <template slot-scope="scope">
            <el-radio :label="scope.row.shopId" :value="currentShopId">
              <span></span>
            </el-radio>
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          :resizable="false"
          show-overflow-tooltip
        ></el-table-column>

        <div class="table-list__empty small" slot="empty"></div>
      </el-table>

      <div class="pagination__wrapper">
        <cd-pagination
          ref="pager"
          :total="pagination.total"
          :currPage="pagination.pageNow"
          :pageSize="pagination.pageSize"
          @changepage="$_changeCurrent"
          @changesize="$_changeSize"
          :explainShow="false"
          @refresh="$_getStoreList"
        ></cd-pagination>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">保存</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
const columns = [
  { key: "storeName", label: "门店" },
  { key: "storeId", label: "门店ID" },
  { key: "provinceName", label: "省份" },
  { key: "cityName", label: "城市" },
  { key: "areaName", label: "区域" }
];

export default {
  name: "modal-select-store",
  props: {
    title: { type: String, default: "" },
    selected: { type: Object, default: {} },
    brandId: { type: Number, default: 0 }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      filter: {
        storeName: "",
        storeId: "",
        provinces: "", // 全部省份
        citys: "", // 全部城市
        districts: "" // 全部行政区域
      },
      selectedStore: {},
      columns,
      dataList: [],
      citys: [], //城市列表
      districts: [], //地区列表
      provinces: [], // 省份列表
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      }
    };
  },
  watch: {
    "filter.provinces"(val) {
      if (val != "") {
        this.$service
          .post("getRegionData", {
            level: "city",
            parentRegionCodeId: -1,
            parentRegionCode: val
          })
          .then(result => {
            if (result.$.checkResult(result, true)) {
              this.citys = result.data.concat([]);
            }
          });
      } else {
        this.citys = [];
      }
      //重置
      this.filter.citys = "";
      this.filter.districts = "";
    },
    "filter.citys"(val) {
      if (val != "") {
        this.$service
          .post("getRegionData", {
            level: "area",
            parentRegionCodeId: -1,
            parentRegionCode: val
          })
          .then(result => {
            if (result.$.checkResult(result, true)) {
              this.districts = result.data.concat([]);
            }
          });
      } else {
        this.districts = [];
      }
      //重置
      this.filter.districts = "";
    }
  },
  computed: {
    currentShopId() {
      if (Object.keys(this.selectedStore).length) {
        return this.selectedStore.shopId;
      }
      return "";
    }
  },
  methods: {
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      this.$_getStoreList();
    },
    // 重置
    $_reset() {
      this.filter.storeId = "";
      this.filter.storeName = "";
      this.filter.provinces = "";
      this.filter.citys = "";
      this.filter.districts = "";
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getStoreList();
    },
    // 选中行变化
    $_changeSelected(row) {
      if (row) {
        this.selectedStore = JSON.parse(JSON.stringify(row));
      } else {
        this.selectedStore = {};
      }
    },
    // 查询品牌列表
    $_getStoreList() {
      this.isLoading = true;
      const postData = {
        brandId: this.brandId,
        storeName: this.filter.storeName,
        storeId: this.filter.storeId,
        provinceCode: this.filter.provinces,
        cityCode: this.filter.citys,
        areaCode: this.filter.districts,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      this.$service.post("getStores", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getStoreList();
    },
    // 切换每页条数
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getStoreList();
    },

    $_submit() {
      if (this.currentShopId && this.currentShopId !== "") {
        this.$emit("callback", this.selectedStore);
        this.$_cancle();
      } else {
        $MessageBox.alert({ content: "请选择相应门店" });
      }
    },

    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  async created() {
    this.$_getStoreList();
    this.selectedStore = {
      storeName: this.selected.storeName,
      storeId: this.selected.storeId,
      shopId: this.selected.shopId
    };
    // 获取省数据
    this.isLoading = true;
    let result = await this.$service.post("getRegionData", {
      level: "province",
      parentRegionCodeId: -1
    });
    this.provinces = result.data.concat([]);
    this.isLoading = false;
  },
  mounted() {
    this.visible = true;
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: 10px 30px 15px;
}
.filter-box {
  position: relative;
  height: 60px;
  border: 1px solid #eee;
  background-color: #f5f6f7;
  padding: 0 10px;
  display: flex;
  justify-content: left;
  align-items: center;
  .autocomplete-box {
    display: inline-block;
    position: relative;

    .autocomplete-empty {
      padding: 10px;
      margin: 0;
      color: #535353;
      top: 33px;
      width: 100%;
    }
  }
}
.filter-keyword__input {
  width: 110px;
  margin-right: 6px;
  &:last-of-type {
    margin-right: 8px;
  }
}
.table-list__box {
  border: 1px solid #eee;
  margin-top: -1px;
  background-color: #f9f9f9;
}
</style>


